import { FC, TextareaHTMLAttributes } from 'react'

import { TextArea as JoorTextArea } from '@joor/design-system'
import { useField } from 'formik'

import { BaseProps } from './Field'

export type PropsType = BaseProps & TextareaHTMLAttributes<HTMLTextAreaElement>

const TextArea: FC<PropsType> = ({ required, ...props }) => {
  const [
    { onChange: _fieldOnChange, onBlur: _fieldOnBlur, ...field },
    meta,
    { setValue, setTouched },
  ] = useField({
    disabled: props.disabled,
    name: props.name,
  })
  const shouldShowError = meta.touched && !!meta.error
  return (
    <JoorTextArea
      onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(event.target?.value)
      }}
      onBlur={() => setTouched(true)}
      isRequired={required}
      {...(shouldShowError && { errorMessage: meta.error })}
      {...field}
      {...props}
    />
  )
}

export default TextArea
